{
  "en": {
    "safetyReviewRecovery": {
      "submissionError": "Failed to submit safety commission review recovery request",
      "submissionSuccess": "Safety commission review analysis started. The table will be updated automatically.",
      "completionError": "Safety commission review analysis failed. Please try again.",
      "noDocumentsSelected": "Please select at least one document",
      "tooManyDocuments": "Please select at most {max} documents"
    }
  },
  "fr": {
    "safetyReviewRecovery": {
      "submissionError": "Échec de l'envoi de la requête de récupération des avis de commission de sécurité",
      "submissionSuccess": "Analyse des avis de commission de sécurité lancée. Le tableau sera mis à jour automatiquement.",
      "completionError": "L'analyse des avis de commission de sécurité a échoué. Veuillez réessayer.",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document",
      "tooManyDocuments": "Veuillez sélectionner au maximum {max} documents"
    }
  },
  "nl": {
    "safetyReviewRecovery": {
      "submissionError": "Fout bij het indienen van het herstelverzoek voor adviezen van de veiligheidscommissie",
      "submissionSuccess": "Analyse van de adviezen van de veiligheidscommissie gestart. De tabel wordt automatisch bijgewerkt.",
      "completionError": "Analyse van de adviezen van de veiligheidscommissie mislukt. Probeer het opnieuw.",
      "noDocumentsSelected": "Selecteer alstublieft minstens één document",
      "tooManyDocuments": "Selecteer alstublieft maximaal {max} documenten"
    }
  }
}
